<ng-container *ngIf="userInfoView; else viewTemplate">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="margin-bottom-4">
    <h2 mat-dialog-title style="margin:0">Please enter your details</h2>
    <i class="icon-cross font-md cursor-pointer" (click)="onNoClick()"></i>
  </div>

  <form class="user-form" [formGroup]="userInfoForm" fxLayout="column" fxLayoutGap="8px">
    <mat-form-field class="width-100">
      <input matInput type="text" formControlName="name" autocomplete="cc-name" placeholder="Full name">
      <mat-error class="sparro-grey-800" *ngIf="formControls.name.errors?.required">Required <sup>*</sup></mat-error>
    </mat-form-field>

    <mat-form-field class="width-100">
      <input matInput type="email" formControlName="email" autocomplete="email" placeholder="Email ID">
      <mat-error class="sparro-grey-800" *ngIf="formControls.email.errors?.required">Required <sup>*</sup></mat-error>
      <mat-error class="sparro-grey-800" *ngIf="formControls.email.errors?.email">Please enter a valid email</mat-error>
    </mat-form-field>

    <mat-form-field class="width-100">
      <input matInput type="number" formControlName="experience" autocomplete="cc-exp" min="0" placeholder="Years of experience">
      <mat-error class="sparro-grey-800" *ngIf="formControls.experience.errors?.required">Required <sup>*</sup></mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="end center">
      <uni-navigation-button
        default="Save"
        button_class="primary"
        [disabled]="!userInfoForm.valid"
        (click)="saveUserDetail()">
      </uni-navigation-button>
    </div>
  </form>
</ng-container>

<ng-template #viewTemplate>
  <section fxLayout="column">
    <ng-container *ngIf="data.upcoming_comp; else compSlug">
      <div fxLayout="column" fxFlex>
        <div fxLayout="row" fxFlex fxLayoutAlign="space-between center">
          <h2 mat-dialog-title style="margin:0">Registration</h2>
          <i class="icon-cross font-md cursor-pointer" (click)="onNoClick()"></i>
        </div>

        <div fxLayout="row">
          <div fxLayout="column" class="width-100">
            <mat-dialog-content style="overflow-y:auto; max-height:192px; min-height:144px;">
              <p class="font-sm sparro-grey-900">
                The registrations for this competitions haven't been started yet.
                Please come back here on: <span class="font-sm font-bold">{{ data.upcoming_comp | date : 'MMM d, y h:mm zz' }} GMT</span>
                If you're interested in early registrations, submit the form here and we will reach out to you with details.
                <span class="font-sm font-bold">Early registration can be availed at 10% lesser fee than regular registration</span>
              </p>
            </mat-dialog-content>
            <mat-dialog-actions align="end" style="padding-top: 0">
              <uni-navigation-button
                default="Register"
                button_class="primary"
                (click)="goToForm()">
              </uni-navigation-button>
            </mat-dialog-actions>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #compSlug>
      <ng-container *ngIf="isLoading; else viewTemplate">
        <div fxLayout="row" fxLayoutAlign="center center" style="height:388px;" fxFlex>
          <uni-loader></uni-loader>
        </div>
      </ng-container>
      <ng-template #viewTemplate>
        <div fxLayout="column" fxFlex *ngIf="!this.isProcessing">
          <div fxLayout="row" fxFlex style="margin-bottom:20px" fxLayoutAlign="space-between center">
            <h2 mat-dialog-title style="margin:0">Select a category</h2>
            <i class="icon-cross font-md cursor-pointer" (click)="onNoClick()"></i>
          </div>

          <div fxLayout="column" class="width-100">
            <mat-dialog-content class="dialog-content">
              <mat-radio-group class="width-100">
                <ng-container *ngFor="let product of products; let i=index; let first=first">
                  <mat-radio-button class="product-radio-button" [checked]="first" color="warn" [value]="product" labelPosition="after" (change)="getSelectedProduct($event)">
                    {{ product.name }}
                    <span>
                      <i class="icon-info" matTooltip="{{ studentInfoArray.join('\n')}}" *ngIf="product.student" style="vertical-align:middle"></i>
                      <i class="icon-info" matTooltip="{{ professionalInfoArray.join('\n')}}" *ngIf="product.professional" style="vertical-align:middle"></i>
                      <i class="icon-info" matTooltip="{{ institutionalInfoArray.join('\n')}}" *ngIf="product.institutional" style="vertical-align:middle"></i>
                    </span>
                  </mat-radio-button>
                </ng-container>
              </mat-radio-group>
            </mat-dialog-content>
            <mat-dialog-content>
              <ul class="additional-info">
                <li class="font-sm">Team members can be added anytime before final submission.</li>
                <li class="font-sm">1 Professional/Student registration indicates 1 entry/group.</li>
                <li class="font-sm">Get <a class="link-text" target="blank" href="https://uni.xyz/about/designers/membership">UNI Institutional Membership</a> for access to 15 entries across any competition on the platform.</li>
              </ul>
            </mat-dialog-content>
            <mat-dialog-actions align="end" style="padding-top: 0; padding-bottom: 16px" *ngIf="!this.isProcessing">
              <uni-navigation-button
                *ngIf="hasMembership && !institutionSelected"
                default="Register using Membership"
                button_class="primary"
                (click)="onClickRegister()">
              </uni-navigation-button>
              <uni-navigation-button
                *ngIf="!hasMembership || (hasMembership && institutionSelected)"
                default="Register"
                button_class="primary"
                (click)="onClickRegister()">
              </uni-navigation-button>
            </mat-dialog-actions>
          </div>
        </div>
      </ng-template>
    </ng-template>

    <ng-container *ngIf="isProcessing">
      <div fxLayout="row" fxLayoutAlign="center center" style="height:400px; width:100%;">
        <uni-loader></uni-loader>
      </div>
    </ng-container>
  </section>
</ng-template>
